import script from "./AppStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStats.vue?vue&type=script&setup=true&lang=ts"

import "./AppStats.vue?vue&type=style&index=0&id=21c481c1&scoped=true&lang=scss"

import exportComponent from "/home/dorian/programy/vue-draft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c481c1"]])

export default __exports__